const FINGERPRINT_ENDPOINT_PATH = '/clientfpid';

export { FINGERPRINT_ENDPOINT_PATH };
